export default "__VITE_ASSET__Ap5l0Cb1__"